function readFile(file) {
  return new Promise((resolve, reject) => {
    const { name, type, size } = file
    let fr = new FileReader()

    fr.onload = (x) => {
      resolve({
        id: Math.random(),
        file,
        preview: window.URL.createObjectURL(file),
        metadata: {
          name,
          type,
          size,
        },
      })
    }

    fr.readAsDataURL(file)
    // fr.readAsArrayBuffer(file) // or readAsText(file) to get raw content
  })
}

export default readFile
